import type { BridgeMessage } from './types'

export function generateId(): string {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 11)}`
}

export function isValidOrigin(messageOrigin: string, expectedOrigin: string): boolean {
  if (expectedOrigin === '*') {
    return true
  }

  try {
    const messageUrl = new URL(messageOrigin)
    const expectedUrl = new URL(expectedOrigin)
    return messageUrl.origin === expectedUrl.origin
  } catch {
    return messageOrigin === expectedOrigin
  }
}

export function isBridgeMessage(data: unknown, tag: string): data is BridgeMessage {
  return (
    typeof data === 'object' &&
    data !== null &&
    (data as Record<string, unknown>).__afterpay_bridge__ === true &&
    (data as Record<string, unknown>).tag === tag &&
    typeof (data as Record<string, unknown>).type === 'string' &&
    typeof (data as Record<string, unknown>).id === 'string'
  )
}

export function withTimeout<T>(promise: Promise<T>, ms: number, operation: string): Promise<T> {
  let timer: ReturnType<typeof setTimeout>
  const timeout = new Promise<never>((_, reject) => {
    timer = setTimeout(() => reject(new Error(`${operation} timed out after ${ms}ms`)), ms)
  })
  return Promise.race([promise, timeout]).finally(() => clearTimeout(timer))
}

export function createLogger(enabled: boolean, tag: string) {
  const prefix = `[@afterpaytouch/bridge:${tag}]`
  return {
    debug: (...args: unknown[]) => enabled && console.debug(prefix, ...args),
    info: (...args: unknown[]) => enabled && console.info(prefix, ...args),
    warn: (...args: unknown[]) => console.warn(prefix, ...args),
    error: (...args: unknown[]) => console.error(prefix, ...args),
  }
}
